/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, TableCell, TableRow } from "@material-ui/core"
import { ModalDeleteConfirm, TableAction } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useDatatables } from "App/hooks"
import {
  defaultToastError,
  formatNumber,
  isNull,
  defaultToastSuccess,
  convertToValidPrice,
} from "App/utils/helpers"
import { FreezeTableClient } from "components/organism"
import React, { useContext, useEffect, useState } from "react"
import { DaftarFasilitas, getTotal, getTotalFilterID, Perhitungan } from ".."
import { FormContext } from "../../context/FormContext"
import {
  getFasilitasByPenjualanID,
  ModalDaftarFasilitas,
  RESET_STATE_DAFTAR_FASILITAS,
  deleteFasilitasById,
} from "./DaftarFasilitas/helpers"

function TabFasilitas({
  perhitunganPenjualan,
  setPerhitunganPenjualan,

  rowsFasilitasByKelas,
  setNewDataFasilitasByKelas,
  loading,

  handleClickReset,

  totalDataFasilitasByKelas,

  formFilterFasilitasByKelas,
  setFormFilterFasilitasByKelas,
}) {
  const [rows, setRows] = useState([])

  const [formFasilitas, setFormFasilitas] = useState(
    RESET_STATE_DAFTAR_FASILITAS,
  )
  const { formData, setFormData } = useContext(FormContext)

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [showModalFasilitas, setShowModalFasilitas] = useState(false)

  const getFasilitasDijual = () => {
    if (isNull(formData.penjualan_id)) {
      const fasilitas = formData.fasilitas.filter(
        (e) =>
          e.kelas_id === formData.kelas_id &&
          e.asuransi_id === formData.asuransi_id,
      )
      setRows(fasilitas)
    }
  }

  const deleteFasilitasDijual = async () => {
    const filterFasilitas = rows.filter((e) => e.id !== formFasilitas.id)

    if (!isNull(formData.penjualan_id)) {
      const totalFasilitas = await getTotalFilterID(
        rows,
        formFasilitas.id,
        "fasilitas",
      )

      const totalBarang = getTotal(formData.barang, "barang")
      const totalRikjang = getTotal(formData.rikjang, "rikjang")
      const totalJasa = getTotal(formData.jasa, "jasa")
      const totalPaket = getTotal(formData.paket, "paket")

      const jumlah =
        totalBarang + totalRikjang + totalFasilitas + totalJasa + totalPaket

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const form = {
        id: formFasilitas.id,
        penjualanId: formData.penjualan_id,
        harga_total_fasilitas: convertToValidPrice(totalFasilitas),
        total_penjualan: convertToValidPrice(jumlah),
        sisa: convertToValidPrice(total),

        tax: taxPercent,
        jumlah_tax: convertToValidPrice(taxNumber),
        discount: convertToValidPrice(formData.potongan / total),
        jumlah_set_discount: potongan,
      }
      const res = await deleteFasilitasById(form)
      if (res.state) {
        setShowModalDeleteConfirm(false)
        await setNewFasilitasDijual(filterFasilitas, false)
        defaultToastSuccess(res.message)
      } else {
        setShowModalDeleteConfirm(false)
        defaultToastError(res.message)
      }
    } else {
      setShowModalDeleteConfirm(false)
      await setNewFasilitasDijual(filterFasilitas, false)
      defaultToastSuccess("List fasilitas berhasil dihapus")
    }
  }

  function clickUpdate(row) {
    setShowModalFasilitas(!showModalFasilitas)

    if (isNull(formData.penjualan_id)) {
      setFormFasilitas({
        id: row.id,
        mh_fasilitas_id: row?.mhFasilitasId,
        fasilitas_id: row?.fasilitas_id,
        qty: row?.qty,
        keterangan: row.qty,
        harga: row.harga,
        hargaCustom: row.hargaCustom,
        hargaCustom2: row.hargaCustom2,
        kelas_id: row.kelas_id,
        asuransi_id: row.asuransi_id,
        namaFasilitas: row.namaFasilitas,
        diskon: row.diskon,
        bed: row?.bed,
      })
    } else {
      setFormFasilitas({
        id: row.id,
        mh_fasilitas_id: row?.mhFasilitasId,
        fasilitas_id: row?.fasilitas_id,
        qty: row?.qty,
        keterangan: row.qty,
        harga: row.harga,
        hargaCustom: row.hargaCustom,
        hargaCustom2: formatNumber(row.hargaCustom),
        namaFasilitas: row.namaFasilitas,

        total: row.hargaCustom * parseInt(row.qty),

        gudang_id: formData.gudang_id,
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        diskon: row.diskon,
        bed: row?.bed,
      })
    }
    setShowModalFasilitas(!showModalFasilitas)
  }

  function clickDelete(row) {
    setFormFasilitas({
      ...formFasilitas,
      id: row?.id,
    })
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  useEffect(() => {
    ;(async () => {
      await setNewDataFasilitasByKelas()
      if (isNull(formData.penjualan_id)) {
        getFasilitasDijual()
      }
    })()
  }, [formData.kelas_id, formData.asuransi_id, formData.reload]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleClickSelect = (row) => {
    if (!isNull(formData.kelas_id)) {
      setFormFasilitas({
        id: "",
        fasilitas_id: row.id_fasilitas,
        mh_fasilitas_id: row.id,
        qty: 1,
        keterangan: "-",
        harga: row.harga_jual,
        hargaCustom: row.harga_jual,
        hargaCustom2: formatNumber(row.harga_jual),
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        namaFasilitas: row.namaMsFasilitas,
        bed: row?.bed,
        diskon: formData.diskon?.diskon_fasilitas ?? 0,
      })

      setShowModalFasilitas(!showModalFasilitas)
    } else {
      defaultToastError("Kelas tidak boleh kosong!")
    }
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: isNull(rows) ? [] : rows,
    orderByDefault: "namaFasilitas",
    orderByRow: ["namaFasilitas"],
  })

  const setNewFasilitasDijual = async (
    fasilitas = formData.fasilitas,
    is_jurnal = formData.is_jurnal,
  ) => {
    const reload = formData.reload_perhitungan || false
    if (isNull(formData.penjualan_id)) {
      setRows(fasilitas)
      setFormData({
        ...formData,
        fasilitas,
        is_jurnal,
        reload_perhitungan: !reload,
      })
    } else {
      const res = await getFasilitasByPenjualanID(formData.penjualan_id)
      if (res.state) {
        setRows(res.data)
        setFormData({
          ...formData,
          fasilitas: res.data,
          is_jurnal,
          reload_perhitungan: !reload,
        })
      }
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isNull(formData.penjualan_id)) {
        await setNewFasilitasDijual()
      }
    })()
  }, [
    formData.gudang_id,
    formData.kelas_id,
    formData.asuransi_id,
    formData.reload,
    formData.penjualan_id,
  ]) // eslint-disable-line react-hooks/exhaustive-deps

  let total = 0

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteFasilitasDijual()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalFasilitas && (
        <ModalDaftarFasilitas
          setShowModal={() => setShowModalFasilitas(false)}
          formFasilitas={formFasilitas}
          setFormFasilitas={setFormFasilitas}
          setNewFasilitasDijual={setNewFasilitasDijual}
          handleClickSelect={handleClickSelect}
          totalPenjualan={perhitunganPenjualan.jumlah}
          sisaPenjualan={perhitunganPenjualan.total}
          setNewDataFasilitasByKelas={setNewDataFasilitasByKelas}
        />
      )}
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6}>
          <DaftarFasilitas
            formFasilitas={formFasilitas}
            setFormFasilitas={setFormFasilitas}
            rows={rowsFasilitasByKelas}
            handleClickSelect={handleClickSelect}
            setNewDataFasilitasByKelas={setNewDataFasilitasByKelas}
            setNewFasilitasDijual={setNewFasilitasDijual}
            totalData={totalDataFasilitasByKelas}
            formFilterFasilitasByKelas={formFilterFasilitasByKelas}
            setFormFilterFasilitasByKelas={setFormFilterFasilitasByKelas}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Perhitungan
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
          />
        </Grid>
      </Grid>

      <div className="mt-1">
        <FreezeTableClient
          title="DAFTAR FASILITAS YANG DIJUAL"
          setQ={setQ}
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              const jumlahRaw = (row.hargaCustom - row.nilai_diskon) * row.qty
              const jumlah = jumlahRaw
              total += jumlah
              return (
                <TableRow key={index}>
                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>

                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {!formData.is_lock && !formData.is_close && (
                      <TableAction
                        clickDelete={() => clickDelete(row)}
                        clickUpdate={() => clickUpdate(row)}
                      />
                    )}
                  </TableCell>
                  <TableCell align="left">{row?.namaFasilitas}</TableCell>
                  <TableCell align="left" width={"5%"}>
                    {row?.qty}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.hargaCustom)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.diskon)}%
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.nilai_diskon)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(jumlah)}
                  </TableCell>
                </TableRow>
              )
            })}
          {rows.length > 0 && (
            <TableRow>
              <TableCell colSpan={headCells.length - 1} align="right">
                TOTAL
              </TableCell>
              <TableCell align="right">{formatNumber(total)}</TableCell>
            </TableRow>
          )}
        </FreezeTableClient>
      </div>
    </>
  )
}

const MemoizeTabFasilitas = React.memo(TabFasilitas)
export default MemoizeTabFasilitas

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "BANYAK",
    align: "left",
  },
  {
    id: "hargaCustom2",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "diskon",
    disablePadding: false,
    label: "DISKON",
    align: "left",
  },
  {
    id: "nilai_diskon",
    disablePadding: false,
    label: "NILAI DISKON",
    align: "left",
  },
  {
    id: "total",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
]
